import React, {useContext} from 'react';
import {AuthContext} from './AuthContext';

const NAVI_WHITELABEL_ID = 1;

export const getWhitelabelFilterOptions = (whitelabelsById = {}) => {
    const options = Object.entries(whitelabelsById).map(([key, whitelabel]) => ({
        ...whitelabel,
        id: Number(whitelabel.id ?? key),
    }));

    if (!options.some(({id}) => id === NAVI_WHITELABEL_ID)) {
        options.push({id: NAVI_WHITELABEL_ID, name: 'Navi'});
    }

    return options.sort((left, right) => left.id - right.id);
};

const WhitelabelFilter = ({value = '', onChange, includeAll = true}) => {
    const {whitelabelsById = {}} = useContext(AuthContext);
    const options = getWhitelabelFilterOptions(whitelabelsById);

    return (
        <select
            aria-label="Filter by whitelabel"
            className="form-control form-control-sm text-center"
            value={value || ''}
            onChange={onChange}
        >
            {includeAll && <option value="">All</option>}
            {options.map((whitelabel) => (
                <option key={whitelabel.id} value={whitelabel.id}>
                    #{whitelabel.id} {whitelabel.name}
                </option>
            ))}
        </select>
    );
};

export default WhitelabelFilter;
